<template>
	<div>
		<v-main style="background-color: white;">
			<router-view />
		</v-main>
	</div>
</template>

<script>
export default {
	name: 'SimpleLayout',
};
</script>
